// frontend/src/utils/permissions.js

// ============================================
// DEFINICIÓN DE PERMISOS
// ============================================
export const PERMISSIONS = {
  // Dashboard
  'view_dashboard': 'Ver Dashboard',
  
  // Clientes
  'view_clients': 'Ver Clientes',
  'create_clients': 'Crear Clientes',
  'edit_clients': 'Editar Clientes',
  'delete_clients': 'Eliminar Clientes',
  
  // Cotizaciones
  'view_quotes': 'Ver Cotizaciones',
  'create_quotes': 'Crear Cotizaciones',
  'edit_quotes': 'Editar Cotizaciones',
  'delete_quotes': 'Eliminar Cotizaciones',
  'upload_quotes': 'Subir PDFs de Cotizaciones',
  
  // Órdenes
  'view_orders': 'Ver Órdenes',
  'create_orders': 'Crear Órdenes',
  'edit_orders': 'Editar Órdenes',
  'delete_orders': 'Eliminar Órdenes',
  'upload_orders': 'Subir PDFs de Órdenes',
  
  // Facilitación
  'view_facilitation': 'Ver Facilitación',
  
  // Finanzas
  'view_finance': 'Ver Finanzas',
  'create_invoices': 'Crear Facturas',
  'edit_invoices': 'Editar Facturas',
  'delete_invoices': 'Eliminar Facturas',
  'manage_finance': 'Gestionar Finanzas',
  
  // Facturación Avanzada
  'upload_invoices': 'Subir Facturas PDF',
  'view_invoice_detail': 'Ver Detalle de Factura',
  'view_cashflow': 'Ver Cobro y Cashflow',
  'view_sales_analysis': 'Ver Análisis de Ventas',
  'mark_invoice_paid': 'Marcar Facturas como Pagadas',
  
  // Facilitadores
  'view_facilitators': 'Ver Facilitadores',
  'manage_facilitators': 'Gestionar Facilitadores',
  
  // Usuarios
  'manage_users': 'Gestionar Usuarios',
  'approve_users': 'Aprobar Usuarios',
  
  // Reportes
  'view_reports': 'Ver Reportes',
};

// ============================================
// NOMBRES DE ROLES
// ============================================
export const ROLE_NAMES = {
  'super_admin': 'Super Administrador',
  'admin': 'Administrador',
  'sales': 'Ventas',
  'finance': 'Finanzas',
  'facilitator': 'Facilitador',
  'viewer': 'Visualizador',
  'custom': 'Personalizado',
};

// ============================================
// PERMISOS POR ROL - SINCRONIZADO CON BACKEND
// ============================================
export const ROLE_PERMISSIONS = {
  'super_admin': ['*'],
  
  'admin': ['*'],
  
  'sales': [
    'view_dashboard',
    'view_quotes', 'create_quotes', 'upload_quotes', 'edit_quotes', 'delete_quotes',
    'view_clients', 'create_clients', 'edit_clients', 'delete_clients',
    'view_orders', 'upload_orders', 'edit_orders', 'delete_orders', 'create_orders',
    'view_facilitation',
    'view_sales_analysis',
    'view_facilitators',
  ],
  
  'finance': [
    'view_dashboard',
    'view_clients', 'create_clients', 'edit_clients', 'delete_clients',
    'view_quotes', 'create_quotes', 'upload_quotes', 'edit_quotes', 'delete_quotes',
    'view_orders', 'upload_orders', 'edit_orders', 'delete_orders', 'create_orders',
    'view_facilitation',
    'view_finance', 'create_invoices', 'edit_invoices',
    'upload_invoices', 'view_invoice_detail', 'view_cashflow', 'view_sales_analysis', 'mark_invoice_paid',
    'view_facilitators', 'manage_facilitators',
    'view_reports',
  ],
  
  'facilitator': [
    'view_dashboard',
    'view_clients',
    'view_quotes',
    'view_facilitation',
  ],
  
  'viewer': [
    'view_dashboard',
    'view_clients',
    'view_quotes',
    'view_orders',
    'view_facilitation',
    'view_cashflow',
    'view_facilitators',
  ],
  
  'custom': [],
};

// ============================================
// FUNCIÓN HELPER
// ============================================
export const hasPermission = (userPermissions, requiredPermission) => {
  if (!userPermissions) return false;
  if (userPermissions.includes('*')) return true;
  return userPermissions.includes(requiredPermission);
};
